module.exports = __webpack_public_path__ + "img/pc2.ba7b7e9f.png";